import React from 'react';
import { useAtom } from 'jotai';
import { Space, Button, Tooltip, Badge } from 'antd';
import { LineChartOutlined, SettingOutlined, InfoCircleOutlined, UserSwitchOutlined, WifiOutlined, ContactsOutlined, AimOutlined, SyncOutlined, ProfileOutlined, CheckOutlined } from '@ant-design/icons';
import { mapState, currentUserState, userNameState, deviceInfoState, isInspectionModalOpenState, mapReprocessTriggerState, userGroupsState, isAllPredictionsPanelOpenState, isValidatedSpectraTableOpenState } from '../stateManagement/commonState';
import { scanningState } from '../stateManagement/processState';
import { showChartsFlag } from '../stateManagement/actionButtonState';
import DownloadCSV from './DownloadCSV';

const ActionButtons = ({ signOut, settingsToggleHandler, deviceInfoToggleHandler, setShowReprocessMapModal, runTest, setWifiConfigModalOpen, setIsTenantsModalOpen, wifiConfigModalOpen, bluetoothState, currentSerial }) => {
  const [map] = useAtom(mapState);
  const [scanning] = useAtom(scanningState);
  const [currentUser, setCurrentUser] = useAtom(currentUserState);
  const [username] = useAtom(userNameState);
  const [userGroups] = useAtom(userGroupsState);
  const [showCharts, setShowCharts] = useAtom(showChartsFlag);
  const [deviceInfo] = useAtom(deviceInfoState);
  const [, setIsInspectionModalOpen] = useAtom(isInspectionModalOpenState);
  const [mapReprocessTrigger, setMapReprocessTrigger] = useAtom(mapReprocessTriggerState);
  const [, setIsAllPredictionsPanelOpen] = useAtom(isAllPredictionsPanelOpenState);
  const [, setIsValidatedSpectraTableOpen] = useAtom(isValidatedSpectraTableOpenState);

  const signOutHandler = () => {
    setCurrentUser(null);
    signOut();
  }

  return (
    <div style={{ position: 'absolute', top: '30px', right: '6%' }}>
      <Space>
        {username === 'admin' ?
          <Tooltip placement='bottomRight' title='Validated Spectra'>
            <Button
              icon={<CheckOutlined />}
              onClick={() => { setIsValidatedSpectraTableOpen(true); }}
            />
          </Tooltip>
          : null
        }

        {(username && userGroups.length && (userGroups.includes('pro_user'))) ?
          <>
            <Tooltip title="All predictions">
              <Button
                icon={<ProfileOutlined />}
                onClick={() => { setIsAllPredictionsPanelOpen(true); }}
              />
            </Tooltip>
            <Tooltip placement='bottomRight' title='Point predictions'>
              <Button
                icon={<AimOutlined />}
                onClick={() => { setIsInspectionModalOpen(true) }}
              />
            </Tooltip>
            <Tooltip placement='bottomRight' title='Charts & filters'>
              <Button
                icon={<LineChartOutlined />}
                onClick={() => { setShowCharts(!showCharts) }}
              />
            </Tooltip>
          </>
          : null}

        {(username && userGroups.length && userGroups.includes('super_user')) ?
          <>
            <Tooltip placement='bottomRight' title='Settings'>
              <Button
                icon={<SettingOutlined />}
                onClick={settingsToggleHandler}
              />
            </Tooltip>
            <DownloadCSV deviceInfo={deviceInfo} currentSerial={currentSerial} />
            {username === 'admin' ?
              <>
                <Tooltip placement='bottomRight' title='Reprocess Map'>
                  <Button
                    icon={<SyncOutlined />}
                    onClick={() => { setMapReprocessTrigger(!mapReprocessTrigger) }}
                  />
                </Tooltip>
                <Tooltip placement='bottomRight' title='Device Info'>
                  <Button
                    icon={<InfoCircleOutlined />}
                    onClick={deviceInfoToggleHandler}
                    disabled={scanning || bluetoothState === 'Disconnected'}
                  />
                </Tooltip>
              </>
              : null}
          </>
          : null}

        <Badge dot status={`${({ '2': 'success', '1': 'success', '0': 'error', '-1': 'warning' }[deviceInfo?.device_network_status] || 'error')}`}>
          <Tooltip placement='bottomRight' title={`${deviceInfo?.device_network_status ? "" : "Connect Device to Wifi"}`}>
            <Button
              icon={<WifiOutlined />}
              onClick={() => setWifiConfigModalOpen(!wifiConfigModalOpen)}
              disabled={scanning || bluetoothState === 'Disconnected'}
            />
          </Tooltip>
        </Badge>

        {(username === 'admin') ? // NOTE: When testing tenant management features locally, add this to test condition  `|| username === 'testing_user'`
          <Tooltip placement='bottomRight' title='Manage Tenants'>
            <Button
              icon={<ContactsOutlined />}
              onClick={() => { setIsTenantsModalOpen(true); }}
            />
          </Tooltip>
          : null
        }

        <Tooltip placement='bottomRight' title={`Logout (${username})`}>
          <Button
            icon={<UserSwitchOutlined />}
            onClick={signOutHandler}
            disabled={scanning}
          />
        </Tooltip>

      </Space>
    </div>
  );
}

export default ActionButtons;
